// extracted by mini-css-extract-plugin
export var image = "videoPlayer-module--image--0f1d5";
export var mediaWrapper = "videoPlayer-module--mediaWrapper--5e2eb";
export var videoPlayer = "videoPlayer-module--videoPlayer--a3916";